import { AlertRow } from '@components/AlertCenter/AlertRows/AlertRow';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { PartnerSettingsAvatar } from '@components/AlertCenter/AlertRows/partnerSettings/PartnerSettingsAvatar';

export const MaterialMarginAlertRow = () => {
  const {
    translate,
    translations: {
      alertCenter: { partnerSettings },
    },
  } = useTranslations();

  const navigate = useNavigate();

  const goToSettings = () => {
    navigate(`/system-settings/economy?modal=partnerMaterialMargin`);
  };

  return (
    <AlertRow
      Icon={<PartnerSettingsAvatar />}
      action={goToSettings}
      title={translate(partnerSettings.materialMargin.title)}
      actionText={translate(partnerSettings.materialMargin.path)}
      subtitle={translate(partnerSettings.subtitle)}
    />
  );
};
